import React from 'react';
import LandingPage from './pages/LandingPage';
import { usePageTracking, useScrollTracking, useTimeTracking } from './hooks/useAnalytics';
import { initGA } from './utils/analytics';

const App = () => {
  // Initialize Google Analytics
  React.useEffect(() => {
    initGA();
  }, []);

  // Enable analytics tracking
  usePageTracking();
  useScrollTracking();
  useTimeTracking();

  React.useEffect(() => {
    // Mobile menu functionality
    const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
    const navMenu = document.querySelector('.nav-menu');
    if (!mobileMenuToggle || !navMenu) return;

    const onToggle = (e) => {
      e.stopPropagation();
      navMenu.classList.toggle('active');
      mobileMenuToggle.textContent = navMenu.classList.contains('active') ? '✕' : '☰';
    };
    const onDocClick = (e) => {
      if (!navMenu.contains(e.target) && !mobileMenuToggle.contains(e.target)) {
        navMenu.classList.remove('active');
        mobileMenuToggle.textContent = '☰';
      }
    };
    const onResize = () => {
      if (window.innerWidth > 768) {
        navMenu.classList.remove('active');
        mobileMenuToggle.textContent = '☰';
      }
    };

    mobileMenuToggle.addEventListener('click', onToggle);
    document.addEventListener('click', onDocClick);
    window.addEventListener('resize', onResize);

    return () => {
      mobileMenuToggle.removeEventListener('click', onToggle);
      document.removeEventListener('click', onDocClick);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return <LandingPage />;
};

export default App;